import { Segment, SegmentsSequence } from '../../domain/segments';
import { toDateTimeStr } from '../../helpers/datetime';
import { DateTimeStr } from '../../types';
import { BaseAPIClient } from '../base_client';

export const SegmentsAPI = {
  fetchRange(
    this: BaseAPIClient,
    stationId: string,
    from: string | number,
    to: string | number,
  ): Promise<readonly Segment[]> {
    const fromStr = new Date(from).toISOString();
    const toStr = new Date(to).toISOString();

    return this.get(`/segments/stations/${stationId}/segments?from=${fromStr}&to=${toStr}`);
  },

  async fetchSequence(
    this: BaseAPIClient,
    stationId: string,
    timestamp: number,
  ): Promise<SegmentsSequence> {
    const { segments } = await this.get<{ segments: SegmentsSequence }>(
      `/segments/stations/${stationId}/segments/sequence/${timestamp}`,
    );

    return segments.map((s) => ({
      ...s,
      datetime: toDateTimeStr(s.startTs),
    }));
  },

  generateAudioURL(this: BaseAPIClient, stationId: string, segmentId: number): string {
    return this.generateUrl(`/segments/stations/${stationId}/segments/${segmentId}/audio`, {
      secure: true,
    });
  },

  fetchThumbnails(
    this: BaseAPIClient,
    stationId: string,
    from: string | number,
    to: string | number,
  ): Promise<{
    data: {
      segmentId: number;
      thumbnailUrl: string;
      metadata: {
        interval: number;
        rows: number;
        columns: number;
        height: number;
        width: number;
      };
    }[];
  }> {
    const fromStr = new Date(from).toISOString();
    const toStr = new Date(to).toISOString();

    return this.get(`/segments/stations/${stationId}/thumbnails?from=${fromStr}&to=${toStr}`);
  },

  fetchThumbnail(
    this: BaseAPIClient,
    stationId: string,
    segmentId: string | number,
  ): Promise<{
    segmentId: number;
    thumbnailUrl: string;
    metadata: {
      interval: number;
      rows: number;
      columns: number;
      height: number;
      width: number;
    };
  }> {
    return this.get(`/segments/stations/${stationId}/${segmentId}/thumbnail`);
  },

  async fetchSegmentAudio(
    this: BaseAPIClient,
    stationId: string,
    segmentId: number,
  ): Promise<Buffer> {
    const { data } = await this.request<Buffer>(
      'GET',
      `/sp/s/${stationId}/segments/${segmentId}/audio`,
      {
        responseType: 'arraybuffer',
        noAuth: true,
      },
    );

    return data;
  },

  fetchTranscription(
    this: BaseAPIClient,
    station: string,
    from: DateTimeStr,
    to: DateTimeStr,
    diarization: boolean,
  ) {
    return this.get(
      `/stations/${station}/transcription?query=_hour&from=${from}&to=${to}&diarization=${diarization}`,
    );
  },
};
